export default __webpack_public_path__ + "static/media/cognishine-logo.dc086a11.png";